export const TYPE_MANUSCRIPT = 'manuscript';
export const TYPE_COVER_LETTER = 'cover_letter';
export const TYPE_REVIEW = 'review';
export const TYPE_PERMISSION = 'permission';
export const TYPE_MANUSCRIPT_BLIND = 'manuscript_blind';

export const ATTACHMENT_PREFIX_MAP = {
    [TYPE_MANUSCRIPT]: 'm',
    [TYPE_COVER_LETTER]: 'c',
    [TYPE_REVIEW]: 'r',
    [TYPE_PERMISSION]: 'p',
    [TYPE_MANUSCRIPT_BLIND]: 'm',
};

export const ATTACHMENT_TITLE_MAP = {
    [TYPE_MANUSCRIPT]: 'types.attachment.manuscript',
    [TYPE_COVER_LETTER]: 'types.attachment.cover_letter',
    [TYPE_REVIEW]: 'types.attachment.review',
    [TYPE_PERMISSION]: 'types.attachment.permission',
    [TYPE_MANUSCRIPT_BLIND]: 'types.attachment.manuscript_blind',
};

export const ATTACHMENT_COLOR_MAP = {
    [TYPE_MANUSCRIPT]: 'success',
    [TYPE_COVER_LETTER]: 'info',
    [TYPE_REVIEW]: 'warning',
    [TYPE_PERMISSION]: 'rose',
    [TYPE_MANUSCRIPT_BLIND]: 'success',
};

export const ATTACHMENT_ICON_CLASS_MAP = {
    [TYPE_MANUSCRIPT]: 'm',
    [TYPE_COVER_LETTER]: 'cl',
    [TYPE_REVIEW]: 'r',
    [TYPE_PERMISSION]: 'p',
    [TYPE_MANUSCRIPT_BLIND]: 'm',
};

//in MB
export const MAX_FILE_SIZE = 5;



// WEBPACK FOOTER //
// ./src/constants/attachments.js